import React from 'react'
import PageNewsletterCampaignContainer from './PageNewsletterCampaignContainer';


const PageNewsletterCampaignSwitchContainer = ({match}) => {
    if('all' === match.params.campaignId) {
        return 'No longer implemented'
    } else {
        return <PageNewsletterCampaignContainer match={match} />
    }
}

export default PageNewsletterCampaignSwitchContainer